var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.908,
    height: 33.908,
    viewBox: "0 0 33.908 33.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reloj",
    transform: "translate(0 0.401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_220",
    "data-name": "Elipse 220",
    cx: 16.954,
    cy: 16.954,
    r: 16.954,
    transform: "translate(0 -0.401)",
    fill: "#49db95"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_221",
    "data-name": "Elipse 221",
    cx: 13.318,
    cy: 13.318,
    r: 13.318,
    transform: "translate(3.636 3.234)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7367",
    "data-name": "Trazado 7367",
    d: "M241.1,54.891q-.534,0-1.057.042a13.319,13.319,0,0,1,0,26.553q.523.041,1.057.042a13.318,13.318,0,0,0,0-26.637Z",
    transform: "translate(-224.146 -51.657)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_195",
    "data-name": "L\\xEDnea 195",
    x2: 2.559,
    transform: "translate(3.838 16.588)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_198",
    "data-name": "L\\xEDnea 198",
    x2: 2.559,
    transform: "translate(27.714 16.588)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_196",
    "data-name": "L\\xEDnea 196",
    x2: 2.559,
    transform: "translate(17.058 3.368) rotate(90)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_197",
    "data-name": "L\\xEDnea 197",
    x2: 2.559,
    transform: "translate(17.058 27.25) rotate(90)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7368",
    "data-name": "Trazado 7368",
    d: "M58.893,72.874A13.979,13.979,0,1,1,72.872,58.895,13.995,13.995,0,0,1,58.893,72.874Zm0-26.636A12.658,12.658,0,1,0,71.551,58.895,12.672,12.672,0,0,0,58.893,46.237Z",
    transform: "translate(-41.94 -42.343)",
    fill: "#3bbc7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check-svgrepo-com",
    transform: "translate(1.902 32.497) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7365",
    "data-name": "Trazado 7365",
    d: "M8.612,10.691a.8.8,0,0,1-1.137,1.137L.236,4.59a.8.8,0,0,1,0-1.137L3.453.236A.8.8,0,1,1,4.59,1.373L1.942,4.021Z",
    transform: "translate(11.335 9.319)",
    fill: "#49db95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7396",
    "data-name": "Trazado 7396",
    d: "M8.612,10.691a.8.8,0,0,1-1.137,1.137L.236,4.59a.8.8,0,0,1,0-1.137L3.453.236A.8.8,0,1,1,4.59,1.373L1.942,4.021Z",
    transform: "translate(11.335 10.172)",
    fill: "rgba(73,219,149,0.48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.db48f09a6a2faa60c0edd4b7d9e4ccc8.svg";
export { ForwardRef as ReactComponent };